import { render, staticRenderFns } from "./address_proof.vue?vue&type=template&id=40695c7d&"
import script from "./address_proof.vue?vue&type=script&lang=js&"
export * from "./address_proof.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports